import React, { useContext } from "react";
import Grid from "@mui/material/Grid2";
import { Button, Paper, Stack, Typography } from "@mui/material";
import DashboardTwoToneIcon from "@mui/icons-material/DashboardTwoTone";
import CalculateTwoToneIcon from "@mui/icons-material/CalculateTwoTone";
import GroupAddTwoToneIcon from "@mui/icons-material/GroupAddTwoTone";
import ArrowOutwardTwoToneIcon from "@mui/icons-material/ArrowOutwardTwoTone";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../components/LanguageContext";

const HomePage = () => {
    const navigate = useNavigate();
    const { translations } = useContext(LanguageContext);
    const isSuperuser = String(localStorage.getItem("role_id")) === "1";

    const items = [
        {
            text: translations.menuCalculations || "Calculations",
            icon: <CalculateTwoToneIcon />,
            route: "/calculations",
            show: true,
        },
        {
            text: translations.menuAddUser || "Users",
            icon: <GroupAddTwoToneIcon />,
            route: "/add-user",
            show: isSuperuser,
        },
        {
            text: translations.menuInstructions || "Instructions",
            icon: <MenuBookIcon />,
            route: "/instructions",
            show: true,
        },
    ].filter((i) => i.show);

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <Paper sx={{ p: 3 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                        <DashboardTwoToneIcon />
                        <Typography variant="h5" sx={{ fontWeight: 600 }}>
                            {translations.homeWelcome || "Welcome to KaproSCM admin panel"}
                        </Typography>
                    </Stack>
                </Paper>
            </Grid>
            {items.map((item) => (
                <Grid key={item.route} size={{ xs: 12, md: 6 }}>
                    <Paper sx={{ p: 3 }}>
                        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                            {item.icon}
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                {item.text}
                            </Typography>
                        </Stack>
                        <Button
                            endIcon={<ArrowOutwardTwoToneIcon />}
                            sx={{ mt: 2 }}
                            fullWidth
                            variant="contained"
                            onClick={() => navigate(item.route)}
                        >
                            {translations.homeAccess || "Access"}
                        </Button>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

export default HomePage;
